import ActionTypes from './actionTypes';

/**
 * Get enrolment status
 * */
export function getEnrolmentStatus(grandParentAccountNumber, contractIdentifier, isConnecting=false) {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.ENROLMENT_STATUS.REQUEST,
    payload:{
      grandParentAccountNumber: grandParentAccountNumber,
      contractIdentifier: contractIdentifier,
      isConnecting: isConnecting,
    }
  };
}

export function getEnrolmentStatusSuccess(response) {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.ENROLMENT_STATUS.SUCCESS,
    payload: {
      enrolmentStatus: response
    },
  };
}

export function getEnrolmentStatusFailure() {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.ENROLMENT_STATUS.FAILURE
  };
}

/**
 * Get MYOB Login URI
 * */
export function getMyobLoginUri(contractIdentifier) {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.MYOB_LOGIN_URI.REQUEST,
    payload:{
      contractIdentifier: contractIdentifier
    }
  };
}

export function getMyobLoginUriSuccess(response) {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.MYOB_LOGIN_URI.SUCCESS,
    payload: {
      myobLoginUri: response.loginUri
    },
  };
}

export function getMyobLoginUriFailure() {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.MYOB_LOGIN_URI.FAILURE
  };
}

/**
 * Disconnect from MYOB
 * */
export function myobDisconnect(grandparentAccountNumber, contractIdentifier) {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.MYOB_DISCONNECT.REQUEST,
    payload:{
      grandparentAccountNumber: grandparentAccountNumber,
      contractIdentifier: contractIdentifier
    }
  };
}

export function myobDisconnectSuccess() {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.MYOB_DISCONNECT.SUCCESS,
  };
}

export function myobDisconnectFailure() {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.MYOB_DISCONNECT.FAILURE
  };
}

/**
 * Get Xero Login URI
 * */
export function getXeroLoginUri(state) {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.XERO_LOGIN_URI.REQUEST,
    payload:{
      state: state
    }
  };
}

export function getXeroLoginUriSuccess(response) {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.XERO_LOGIN_URI.SUCCESS,
    payload: {
      xeroLoginUri: response.loginUri
    },
  };
}

export function getXeroLoginUriFailure() {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.XERO_LOGIN_URI.FAILURE
  };
}

/**
 * Connect to Xero
 * */
export function xeroConnect(grandparentAccountNumber, contractIdentifier, authorizationCode) {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.XERO_CONNECT.REQUEST,
    payload:{
      grandparentAccountNumber: grandparentAccountNumber,
      contractIdentifier: contractIdentifier,
      authorizationCode: authorizationCode
    }
  };
}

export function xeroConnectSuccess() {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.XERO_CONNECT.SUCCESS,
  };
}

export function xeroConnectFailure() {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.XERO_CONNECT.FAILURE
  };
}

/**
 * Disconnect from Xero
 * */
export function xeroDisconnect(grandparentAccountNumber, contractIdentifier) {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.XERO_DISCONNECT.REQUEST,
    payload:{
      grandparentAccountNumber: grandparentAccountNumber,
      contractIdentifier: contractIdentifier
    }
  };
}

export function xeroDisconnectSuccess() {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.XERO_DISCONNECT.SUCCESS,
  };
}

export function xeroDisconnectFailure() {
  return {
    type: ActionTypes.ACCOUNTING_INTEGRATION.XERO_DISCONNECT.FAILURE
  };
}
